import useAuth from '@package/hooks/src/useAuth';
import config from 'config-base';

import Avatar from '../Avatar';
import Link from '../Link';
import Popover from '../Popover';

import styles from './AppBarPopup.module.css';
import { AppbarPopupProps, AppbarPopupLoggedProps } from './types';

const RegisteredMenu = ({ logout }: AppbarPopupLoggedProps) => {
  return (
    <ul className={styles.userAccountList}>
      <span className={styles.userNameIcon} onClick={() => close()} />
      <li>
        <Link data-testid={'app-bar-popup-account-link'} href={config.myAccountUrl} showCursorPointer={true} classes={styles.popoverLinks}>
          My Account
        </Link>
      </li>
      <li>
        <Link data-testid={'app-bar-popup-orders-link'} href={config.myOrdersUrl} showCursorPointer={true} classes={styles.popoverLinks}>
          My Orders
        </Link>
      </li>
      <li>
        <Link data-testid={'app-bar-popup-bb-link'} href={config.bullseyeBucksUrl} showCursorPointer={true} classes={styles.popoverLinks}>
          Bullseye Bucks
        </Link>
      </li>
      <li>
        <Link data-testid={'app-bar-popup-gift-card-link'} href={config.myGiftCardUrl} showCursorPointer={true} classes={styles.popoverLinks}>
          Gift Cards
        </Link>
      </li>
      <li>
        <Link data-testid={'app-bar-popup-logout-link'} onClick={() => logout()} showCursorPointer={true} classes={styles.popoverLinks}>
          Logout
        </Link>
      </li>
    </ul>
  );
};

const GuestMenu = () => {
  return (
    <ul className={styles.userAccountList}>
      <li>
        <Link data-testid={'app-bar-popup-sign-in-link'} href={config.signInUrl} showCursorPointer={true} classes={styles.popoverLinks}>
          Sign In
        </Link>
      </li>
      <li>
        <Link data-testid={'app-bar-popup-sign-up-link'} href={config.signUpUrl} showCursorPointer={true} classes={styles.popoverLinks}>
          Create Account
        </Link>
      </li>
    </ul>
  );
};

const AppBarPopup = ({ headerHeight }: AppbarPopupProps) => {
  const { user, logout } = useAuth();
  return (
    <>
      {!user ? (
        <Popover
          id="guest-menu"
          headerHeight={headerHeight}
          anchorComponent={
            <div data-testid={'app-bar-popup-trigger'} className={styles.personalLink}>
              <Avatar id="guest-avatar" />
            </div>
          }
          popoverContent={<GuestMenu />}
          containerClassName={styles.popoverContainer}
          contentClassName={styles.popoverContent}
          isHeaderPopover={true}
        />
      ) : (
        <Popover
          id="registered-menu"
          contentClassName={styles.popoverContent}
          containerClassName={styles.popoverContainer}
          headerHeight={headerHeight}
          isHeaderPopover={true}
          anchorComponent={
            <div className={styles.greetingContainer}>
              <Avatar data-testid={'app-bar-popup-register-trigger'} id="registered-avatar" fullName={`${user?.firstName} ${user?.lastName}`} />
            </div>
          }
          popoverContent={<RegisteredMenu logout={logout} />}
        />
      )}
    </>
  );
};

export default AppBarPopup;
